import { useEffect } from "react";
import { useParams } from "next/navigation";
import { useRouter } from "next/navigation";
import { type SupportedLanguage } from "@/lib/shared";
import { localizedPath } from "@/lib/localePath";
import { resolveLocale } from "@/lib/resolvedLocale";

/** SPA: تسجيل الدخول تحت `/:locale/auth/login` وليس `/login` */
export const useAuthRedirect = () => {
  const router = useRouter();
  const params = useParams();

  useEffect(() => {
    const handleUnauthorized = () => {
      const locale: SupportedLanguage = resolveLocale(
        params.locale as string | undefined,
      );
      router.replace(localizedPath(locale, "/auth/login"));
    };

    window.addEventListener(
      "auth:unauthorized",
      handleUnauthorized as EventListener,
    );

    return () => {
      window.removeEventListener(
        "auth:unauthorized",
        handleUnauthorized as EventListener,
      );
    };
  }, [router, params.locale]);
};
